module.exports = "/39bb3e7e8937f496cb467bc96740c1d5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/header.png
 ** module id = 2217
 ** module chunks = 0
 **/